import { BRANDING_REPORT } from './branding-report';
import { formatCell } from './columns';

import type { ModuleReportView } from './module-report-types';

/**
 * Which module page the final report uses, by `moduleId`. A module with no
 * entry gets the generic one: its record's `columns()` as label → value, no
 * preview, no module observations — the report still renders, just plainer.
 */

export const GENERIC_REPORT: ModuleReportView = {
    recordNoun: 'record',
    table: (record, columns) => ({
        kind: 'values',
        rows: columns.map((column) => ({
            label: column.label,
            value: formatCell(record.columns[column.key]),
        })),
    }),
    preview: () => null,
    recordChip: () => null,
    facts: () => [],
    observations: () => [],
    explainedWarningCodes: new Set(),
    warningTopic: () => null,
};

const MODULE_REPORTS: ReadonlyMap<string, ModuleReportView> = new Map([
    ['branding', BRANDING_REPORT],
]);

export function moduleReportView(moduleId: string): ModuleReportView {
    return MODULE_REPORTS.get(moduleId) ?? GENERIC_REPORT;
}
